import React, { useEffect, useState } from 'react';
import "../Electrician/Electrician.css"
import { useNavigate } from "react-router-dom";
const Carpetner = ({ cart, addToCart }) => {
  const navigate = useNavigate();
  const [openService, setOpenService] = useState(null);
  const services = [
    {
      id: 601,
      title: "Door Repair",
      price: 249,
      subtitle: "Fix jamming / loose / misaligned doors",
      extra_detail_1: "Fix stuck or noisy door problems",
      extra_detail_2: "Align hinges and ensure smooth closing",
      image: "https://content.jdmagicbox.com/comp/def_content_category/door-repair-and-services/81abee7edc-door-repair-and-services-2-s2w8j.jpg"
    },
    {
      id: 602,
      title: "Door Lock Repair",
      price: 199,
      subtitle: "Fix door lock issues",
      extra_detail_1: "Repair faulty or jammed door locks",
      extra_detail_2: "Ensure smooth and secure locking",
      image: "https://content.jdmagicbox.com/comp/def_content/lock-repair-and-services/8-lock-repair-and-services-8-1c2z0.jpg"
    },
    {
      id: 603,
      title: "Chair Repair",
      price: 149,
      subtitle: "Fix broken or unstable chair",
      extra_detail_1: "Fix loose legs and broken joints",
      extra_detail_2: "Restore chair strength and stability",
      image: "https://hips.hearstapps.com/popularmechanics/assets/cm/15/05/54cad878ee11d_-_wobbly-chairs-0112-h74afh-mdn.jpg"
    },
    {
      id: 604,
      title: "Table Repair",
      price: 249,
      subtitle: "Fix damaged tables",
      extra_detail_1: "Repair broken table legs or surface",
      extra_detail_2: "Ensure strong and stable table support",
      image: "https://media.istockphoto.com/id/1265520647/photo/broken-chair-woman-is-holding-it-in-hands-old-furniture.jpg?s=612x612&w=0&k=20&c=arE9e8oOihOZH_YrfBlolcpB6qGE2Wmqljje-7hRlg4="
    },
    {
  id: 605,
  title: "Wooden Chair Repair",
  price: 99,
  subtitle: "Fix damaged wooden chairs",
  extra_detail_1: "Repair broken legs, joints, or seat",
  extra_detail_2: "Ensure durability and stability",
  image: "https://images.openai.com/static-rsc-3/BYFSr4GqKIHIud94LuMguq2RE5ldn8F0AlDkxY2DjRhSjp1uANHbVeQrcqEhoErc-9CgxtXG3xD0YBDOcyWBkm8ldGuaWdxupg20AVuSitY?purpose=inline"
},
{
  id: 606,
  title: "Door Repair",
  price: 199,
  subtitle: "Fix door issues",
  extra_detail_1: "Repair hinges, alignment, and locks",
  extra_detail_2: "Ensure smooth opening and closing",
  image: "https://images.openai.com/static-rsc-3/8T4qh77GkfA6xiuBZMf8ZDCIyFW_UspFtp8q3nJAQQeX1PkooAguEC5RXVKhZgsVqyRlnoVrkdokti5eAwdWXOcjZ4NjT01KRJwZOLc-HH8?purpose=inline"
},
{
  id: 607,
  title: "Door Installation",
  price: 419,
  subtitle: "Install new doors",
  extra_detail_1: "Professional fitting and alignment",
  extra_detail_2: "Ensure secure and durable setup",
  image: "https://images.openai.com/static-rsc-3/VpgHDA-uQRk7ZH_8w1UJIVjg4Oq1p6YpvciCH1xI2I7z9Wj3aqffRfCBvQKJ0A0apFMG5KzcG9xfD6Mfb6t9HNjsm0V_jOTZ5zWUISkNGEY?purpose=inline"
},
{
  id: 608,
  title: "Cupboard Lock & Latches",
  price: 79,
  subtitle: "Fix cupboard locking system",
  extra_detail_1: "Repair or replace locks and latches",
  extra_detail_2: "Ensure proper locking functionality",
  image: "https://m.media-amazon.com/images/I/61%2B8kjF6xqS._AC_UF1000%2C1000_QL80_.jpg"
},
{
  id: 609,
  title: "Drawer Repair and Installation",
  price: 89,
  subtitle: "Fix or install drawers",
  extra_detail_1: "Repair sliding issues or install new drawers",
  extra_detail_2: "Ensure smooth operation",
  image: "https://images.openai.com/static-rsc-3/aTqzzhTFcjwz7PFNRtftEKVuA4hvN8aHxBDS1XZQhBPO6gp9ltLWKDRgFDy_pCCp9DmXBXc582RD6QHUTKwE3k_EFhgf9yVlrs9pIiSORno?purpose=inline"
},
{
  id: 610,
  title: "Pull-out Drawer Repair/Replacement",
  price: 129,
  subtitle: "Fix pull-out drawers",
  extra_detail_1: "Repair or replace damaged channels",
  extra_detail_2: "Ensure smooth sliding mechanism",
  image: "https://m.media-amazon.com/images/I/41ld2irjndL._AC_UF1000%2C1000_QL80_.jpg"
},
{
  id: 611,
  title: "Cabinet Hinges",
  price: 99,
  subtitle: "Fix cabinet hinges",
  extra_detail_1: "Repair or replace damaged hinges",
  extra_detail_2: "Ensure proper door alignment",
  image: "https://images.openai.com/static-rsc-3/drp3d87MA0_7CcwjApmDFord90dEo23BOtpYPZxc3osXcfZ7CKmW-OE2Iz77EtrSGqAW7cHfZTZF19k3ZljjT3giLBzbE28V60r2O_NEveE?purpose=inline"
},
{
  id: 612,
  title: "Cabinet Hydraulic Repair",
  price: 99,
  subtitle: "Fix hydraulic cabinet systems",
  extra_detail_1: "Repair soft-close mechanisms",
  extra_detail_2: "Ensure smooth and silent operation",
  image: "https://m.media-amazon.com/images/I/51gv2eJ0FxL._AC_UF1000%2C1000_QL80_.jpg"
},
{
  id: 613,
  title: "Utensil Rack Installation",
  price: 199,
  subtitle: "Install kitchen racks",
  extra_detail_1: "Secure wall-mounted rack installation",
  extra_detail_2: "Ensure proper alignment and strength",
  image: "https://m.media-amazon.com/images/I/51y7ZsKWdSL._AC_UF1000%2C1000_QL80_.jpg"
},
{
  id: 614,
  title: "Decor Installation",
  price: 79,
  subtitle: "Install decorative items",
  extra_detail_1: "Mount frames, wall art, and décor",
  extra_detail_2: "Ensure neat and secure placement",
  image: "https://hips.hearstapps.com/hmg-prod/images/gettyimages-609179845-1516893046.jpg?crop=0.673xw%3A1.00xh%3B0.0554xw%2C0&resize=1200%3A%2A"
},
{
  id: 615,
  title: "Mirror Installation",
  price: 119,
  subtitle: "Install wall mirrors",
  extra_detail_1: "Secure mounting with proper alignment",
  extra_detail_2: "Ensure safety and stability",
  image: "https://images.openai.com/static-rsc-3/__WV4e5rZ1e6IpBRFauFPUym2vyP1xTvSTARyEeUQ6s3o9l8PJEcRlVKPYYDFRIPfTflF1J5VIO1HXbco4Z06QMPt1IQFd7ob_2RH9gaARM?purpose=inline"
},
{
  id: 616,
  title: "Wall Cabinet Assembly & Installation",
  price: 199,
  subtitle: "Assemble and install cabinets",
  extra_detail_1: "Proper fitting and alignment",
  extra_detail_2: "Ensure strong wall mounting",
  image: "https://dam.thdstatic.com/content/production/8NfivYLBFwHx7VZUkmx3JA/x3hAvbyrCN1KozKM7l6xDw/Original%20file/how-to-install-wall-cabinets-step-12.jpg"
},
{
  id: 617,
  title: "Bathroom Mirror Cabinet Installation",
  price: 499,
  subtitle: "Install mirror cabinets",
  extra_detail_1: "Secure bathroom cabinet setup",
  extra_detail_2: "Ensure durability in wet areas",
  image: "https://www.bathroomcity.co.uk/sites/default/files/styles/blogm_desktop-sm/public/blog/A%20Man%20Installing%20Bathroom%20Mirror%20Cabinet.jpg"
},
{
  id: 618,
  title: "Drill (Per Hole)",
  price: 49,
  subtitle: "Drilling service",
  extra_detail_1: "Accurate hole drilling in walls",
  extra_detail_2: "Suitable for fittings and fixtures",
  image: "https://images.openai.com/static-rsc-3/mW_0lujVzuh3AViqTIbQZuGuGDe5-L1wGVEX8yka8BbCQKbXjz23OBnMfaZs5zaGP5BsDmSFfX_btxfNXRCqwS9cmv0BuUzdAbolw15QYd0?purpose=inline"
},
{
  id: 619,
  title: "Soap Holder Installation",
  price: 99,
  subtitle: "Install soap holders",
  extra_detail_1: "Secure bathroom accessory fitting",
  extra_detail_2: "Ensure proper alignment",
  image: "https://images.openai.com/static-rsc-3/qKD5vwrty9pb7DQrzxI9c_mGjuHh45b6z2UXYL8bHA3jU8EkmUQ-kw8MlZuVixEkDTXWFkWTWemZhPwi-FwibBvDFSMbJs_ZG0x_dngrOD4?purpose=inline"
},
{
  id: 620,
  title: "Towel Holder Installation",
  price: 99,
  subtitle: "Install towel holders",
  extra_detail_1: "Wall-mounted installation",
  extra_detail_2: "Ensure strong and stable fitting",
  image: "https://images.openai.com/static-rsc-3/edhycaBVZZtUTBGn4LEdVzxFKcfA6rcOTGVU-HSsOSwzGghJodk9qdgjmgPo6chlKbrGRszJcTSCvQeKHIN7NAundlOtF8U6F6N-5jBJYlU?purpose=inline"
},
{
  id: 621,
  title: "Door Repair",
  price: 199,
  subtitle: "Fix damaged doors",
  extra_detail_1: "Repair hinges and alignment",
  extra_detail_2: "Ensure smooth usage",
  image: "https://www.doorrepairhamilton.ca/userfiles/images/door-repair/about-door.jpg"
},
{
  id: 622,
  title: "Door Accessories & Mesh Installation",
  price: 79,
  subtitle: "Install door accessories",
  extra_detail_1: "Fix mesh and fittings",
  extra_detail_2: "Improve usability and protection",
  image: "https://images.openai.com/static-rsc-3/4hofZaU1csN3ZkOD-4p0OH-lS633aQgthDZbUgDH_UQXTkQCttMcPHO_ISwBi5DdirFOqOprs1oeuvK0h02g_kE_Ixjqy4lQDiXWWhMpt8o?purpose=inline"
},
{
  id: 623,
  title: "Door Close Installation",
  price: 419,
  subtitle: "Install door closers",
  extra_detail_1: "Automatic closing system setup",
  extra_detail_2: "Ensure smooth closing action",
  image: "https://images.openai.com/static-rsc-3/CqMGPAYQ9dPmc54kuZ7NHWXxSL51mpeELrgb-lVgSh7hKqOrCvmUhkdAZDFT7s-ap-iiXnwS04D7HolRQcfZtsMDaKGuP-ZEJAmS_NCuO7Q?purpose=inline"
},
{
  id: 624,
  title: "Door Lock Repair & Installation",
  price: 219,
  subtitle: "Fix or install door locks",
  extra_detail_1: "Repair faulty locks or install new ones",
  extra_detail_2: "Ensure safety and security",
  image: "https://images.openai.com/static-rsc-3/VX878WQP7HlJZLzZnBltf0AEptklkhybgUScdvMDJ9Ysm_3lGOezEq9zx43UbnyG1Dd6ElrJM8wM2lFbOlZd3_KKTIl2VaKqeWpo0i1ZF7E?purpose=inline"
},
{
  id: 625,
  title: "Mosquito Net Installation",
  price: 149,
  subtitle: "Install mosquito nets",
  extra_detail_1: "Fix window/door nets",
  extra_detail_2: "Ensure proper fitting and protection",
  image: "https://images.openai.com/static-rsc-3/9qdJcFU7PqicgZtgpYza6x_99xOQZy8-7DUadOyawapnWXh77aoLPtxjlVtsMfCVYWroCPdZm3nwFP6s0iyU-mkuyPaiZRsJjp0ZfzmpQ3g?purpose=inline"
},
{
  id: 626,
  title: "Blinds Inspection & Measurement (upto 5 ft)",
  price: 49,
  subtitle: "Check and measure blinds",
  extra_detail_1: "Accurate measurement service",
  extra_detail_2: "Prepare for proper installation",
  image: "https://senseblinds.com/cdn/shop/articles/v2-w9zct-19e9l_fe0ec9b0-f466-4b00-8365-688f57697070.jpg?v=1773646015&width=1213"
},
{
  id: 627,
  title: "Window Accessories",
  price: 89,
  subtitle: "Install window fittings",
  extra_detail_1: "Fix handles, locks, and accessories",
  extra_detail_2: "Ensure smooth operation",
  image: "https://contentgrid.homedepot-static.com/hdus/en_US/DTCCOMNEW/Articles/how-to-install-window-locks-2023-hero.jpg"
},
{
  id: 628,
  title: "Window Misalignment / Jam Repair",
  price: 149,
  subtitle: "Fix window issues",
  extra_detail_1: "Repair jammed or misaligned windows",
  extra_detail_2: "Ensure smooth sliding",
  image: "https://www.mrhandyman.com/brand/_assets/images/brand-img/service-details/mrh_window_screwdriver_desktop_660x639.webp"
},
{
  id: 629,
  title: "Curtain Rod Installation",
  price: 149,
  subtitle: "Install curtain rods",
  extra_detail_1: "Secure wall mounting",
  extra_detail_2: "Ensure proper alignment",
  image: "https://www.thecurtainco.co.nz/cdn/shop/files/The_Rockford_Rod_Black_Installation.jpg?v=1755034597&width=1500"
},
{
  id: 630,
  title: "Bed Support Repair",
  price: 249,
  subtitle: "Fix bed structure",
  extra_detail_1: "Repair damaged support panels",
  extra_detail_2: "Ensure strong base",
  image: "https://assistor.in/uploads/services/171203387579abee3a-34f9-4af8-bebb-77faa54405b0_.jpg"
},
{
  id: 631,
  title: "Headboard Repair",
  price: 219,
  subtitle: "Fix headboards",
  extra_detail_1: "Repair loose or broken parts",
  extra_detail_2: "Enhance durability",
  image: "https://cdn.outrank.so/d211207b-c7ed-4d9d-9739-ed63dfc10c5e/dc47a164-7262-41bd-b14a-da11b2b8db0e.jpg"
},
{
  id: 632,
  title: "Wooden Table Repair",
  price: 49,
  subtitle: "Fix wooden tables",
  extra_detail_1: "Repair cracks and damages",
  extra_detail_2: "Ensure stability",
  image: "https://images.openai.com/static-rsc-3/uFqOkf2y_vpmL1vwQZJ9lyrwl8YzbzvBB9jYX1pkzHs-kza25PZTGwXItO79HsVmctMbVR19raGDmpADuOOrxGvBEo6EXJi1faccu6D1sEA?purpose=inline"
},
{
  id: 633,
  title: "Wooden Sofa Repair",
  price: 49,
  subtitle: "Fix wooden sofas",
  extra_detail_1: "Repair frame and joints",
  extra_detail_2: "Improve durability",
  image: "https://images.openai.com/static-rsc-1/ZC9-bt3gtD7zOUh0EUkTCHYdkIBgfJW2zfhEVgK6daTWLnuTQvAJsGqfQQGcz3nPGvNTvaZgrSCYaxexe7uJDpbiFpzlacjI6BccMcoplS1N9JMpr8a_CB25dZ273AuLSK9S4QiO5XaPEBwk773yXA"
},
{
  id: 634,
  title: "Ceiling Mounted Hanger Installation",
  price: 499,
  subtitle: "Install ceiling hangers",
  extra_detail_1: "Secure installation on ceiling",
  extra_detail_2: "Ensure strong load support",
  image: "https://www.georgeandwilly.com/cdn/shop/files/Clothes-Hanging-Drying-Rack.jpg?v=1736303907&width=1200"
},
{
  id: 635,
  title: "Wall Hanger Installation",
  price: 119,
  subtitle: "Install wall hangers",
  extra_detail_1: "Fix hooks and hangers securely",
  extra_detail_2: "Ensure proper alignment",
  image: "https://m.media-amazon.com/images/I/71a%2B9eQTr9L._AC_UF1000%2C1000_QL80_.jpg"
}
  ]
  return (
    <div className='container-fluid service-electrician'>
      <div id="Electronic">
        <h1>Carpenter</h1>
      </div>
      <div className='elect-container'>
        <div className="services-section-elect">
          {services.map((service) => {
            const isAdded = cart.some(
              item => item.id === service.id && item.category === service.category
            );
            return (
              <div key={service.id} className="service-card-elect">

                <div className="service-details-elect">
                  <h3>{service.title}</h3>

                  <div className="price-section-elect">
                    <span className="new-price-elect">₹{service.price}</span>
                  </div>
                  <button
                    className=" btn btn-link view-details-elect"
                    onClick={() =>
                      setOpenService(openService === service.id ? null : service.id)
                    }
                  >
                    View Details
                  </button>
                  {openService === service.id && (
                    <div className="extra-details-elect">
                      <p>✔ {service.extra_detail_1}</p>
                      <p>✔ {service.extra_detail_2}</p>
                    </div>
                  )}

                  <ul>
                    <li>{service.subtitle}</li>
                  </ul>
                </div>

                <div className="service-image-elect">
                  <img src={service.image} alt="" /><br />
                  <button
                    onClick={() => addToCart(service)}
                    className={`btn px-5 mt-2 ${isAdded ? "btn-success" : "btn-warning"
                      }`}
                  >
                    {isAdded ? "Added" : "Add"}
                  </button>
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default Carpetner